import * as React from 'react';
import { Icon } from './Icon';
import { cn } from '@/lib/utils';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  selectSize?: 'sm' | 'md' | 'lg';
}

// Native <select> styled to match the design's primitive Select. We use the
// native element on purpose: it's accessible, mobile-friendly, and we don't
// need the heavier Radix Select for the few onboarding dropdowns.
export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, selectSize = 'md', children, ...props }, ref) => {
    const h = { sm: 'h-8', md: 'h-10', lg: 'h-12' }[selectSize];
    return (
      <div className="relative flex">
        <select
          ref={ref}
          className={cn(
            'w-full appearance-none rounded-md border border-line bg-paper pl-3 pr-9 text-sm text-ink outline-none focus-visible:border-line-2 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:opacity-50',
            h,
            className,
          )}
          {...props}
        >
          {children}
        </select>
        <Icon
          name="chevron_down"
          size={14}
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-muted"
        />
      </div>
    );
  },
);
Select.displayName = 'Select';
